import { Component, OnInit, Output, EventEmitter, Input, SimpleChanges } from '@angular/core';
import { AppMenu } from '../../models/app-menu';
import { ProjectPage } from '../../../features/project/models/project-page';
import APP_MENU from '../../../../assets/menu/app-menu.json';
import { ProjectConfiguration } from '../../../features/project/models/project-configuration';

@Component({
  selector: 'app-menu',
  template: require('./menu.component.html'),
  styles: [require('./menu.component.sass')]
})
export class MenuComponent implements OnInit {

  @Input() activePages: String[];
  @Input() projectConfiguration: ProjectConfiguration;
  @Input() isAdmin: boolean;
  @Output() click = new EventEmitter<AppMenu>();

  appMenu: AppMenu[];

  constructor() { }

  ngOnInit(): void {
    this.generateMenu();
  }

  ngOnChanges(changes: SimpleChanges): void {
    this.generateMenu();
  }

  generateMenu = () => {
    const unusedPages = this.projectConfiguration && this.projectConfiguration.frontendMenu && this.projectConfiguration.frontendMenu.unusedPages;
    let allAppMenu: AppMenu[] = APP_MENU.menu;
    if (unusedPages && unusedPages.length > 0) {
      this.disableUnusedPages(allAppMenu, unusedPages);
    }

    if (this.isAdmin) {
      this.appMenu = [...allAppMenu];
    } else {
      this.setMenuVisibility(allAppMenu, this.activePages);
      this.appMenu = allAppMenu
    }
    this.disableParentWithoutChildSubMenu(this.appMenu)
  }

  onMenuClick = (item: AppMenu) => {
    this.click.emit(item);
  }

  disableUnusedPages = (menuItems: AppMenu[], unusedPages: String[]) => {
    return menuItems.forEach(subMenu => {
      subMenu.visible = true;
      if (subMenu.items && subMenu.items.length > 0) {
        return this.disableUnusedPages(subMenu.items, unusedPages)
      } else {
        subMenu.visible = !unusedPages.find(page => page === subMenu.page);
      }
    }) 
  }

  setMenuVisibility = (menuItems: AppMenu[], activePages: String[]) => {
    return menuItems.forEach(subMenu => {
      subMenu.visible = false;
      if (subMenu.items && subMenu.items.length > 0) {
        return this.setMenuVisibility(subMenu.items, activePages)
      } else {
        subMenu.visible = !!activePages.find(page => page === subMenu.page);
      }
    }) 
  }

  disableParentWithoutChildSubMenu = (menuItems: AppMenu[], parent?: AppMenu, greatParent?: AppMenu) => {
    if (greatParent) {
      greatParent.visible = !! (greatParent.items && greatParent.items.reduce((acc: boolean, item) => acc || item.visible, false))
    }
    return menuItems.forEach(subMenu => {
      if (subMenu.items && subMenu.items.length > 0) {
        subMenu.visible = subMenu.items.reduce((acc: boolean, item) => acc || item.visible, false)
        if (parent) {
          parent.visible = parent.visible || subMenu.items.reduce((acc: boolean, item) => acc || item.visible, false)
        }
        return this.disableParentWithoutChildSubMenu(subMenu.items, subMenu, parent);
      } else {
        
      }
    }) 
  }

}
